import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Icon, PracticeLogo } from "components";
import { Assignment } from "types";

type PublicAssignmInfo = {
  therapistName: string;
  therapistEmail: string;
  therapistIcon: string;
  practiceName: string;
  practiceLogo: string;
  groupName: string;
  assignment: Assignment;
};
interface Props {
  publicAssignmentInfo: PublicAssignmInfo;
}

const PublicInfoSection = ({ publicAssignmentInfo }: Props) => {
  const { t } = useTranslation("common");

  const {
    therapistName,
    therapistIcon,
    therapistEmail,
    practiceLogo,
    groupName,
  } = publicAssignmentInfo;

  const therapistIconFormatted =
    therapistIcon[0].toUpperCase() + therapistIcon.slice(1);

  return (
    <div className="fill-modal_info">
      <section className="fill-modal_info_therapist">
        {practiceLogo && <PracticeLogo image={practiceLogo} position="left" />}
      </section>

      <p className="fill-modal_info_sent-by">{t("share_link.sent_by_label")}</p>

      <section className="fill-modal_info_section">
        <div className="fill-modal_info_image">
          <div className="fill-modal_info_avatar">
            {therapistIcon ? (
              <Icon src={therapistIconFormatted} />
            ) : (
              <Avatar fullName={therapistName} />
            )}
          </div>
        </div>
        <span className="fill-modal_info_name">{therapistName}</span>
      </section>

      <section className="fill-modal_info_section">
        <div className="fill-modal_info_image">
          <div className="fill-modal_info_icon">
            <Icon src={"Envelope"} />
          </div>
        </div>
        <span className="fill-modal_info_email">{therapistEmail}</span>
      </section>

      {groupName && (
        <section className="fill-modal_info_section">
          <div className="fill-modal_info_image">
            <div className="fill-modal_info_icon">
              <Icon src={"Group2"} />
            </div>
          </div>
          <span className="fill-modal_info_text">{groupName}</span>
        </section>
      )}
      <div className="fill-modal_info_brand">reflective</div>
    </div>
  );
};

export default PublicInfoSection;
